<div class="main-content" *ngIf="!loading">
  <h2 class="support-dialog-title" fxLayout fxLayoutAlign="center center">
    <span fxFlex=""></span>
    <span class="shine">SERVICE COMMERCIAL</span>
    <span fxFlex=""></span>
    <button style="background-color: transparent; border:none" (click)="closeDialog()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="#fff" d="M18 13h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5V6a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2z" transform="rotate(45 12 12)" />
      </svg>
    </button>
  </h2>

  <div class="support-dialog-content" *ngIf="parameter$ | async as parameter">
    <p *ngIf="comemrcialName">
      Votre commercial: <strong>{{ comemrcialName }}</strong>
    </p>

    <dl *ngIf="telInfo" fxLayout fxLayoutGap="20px">
      <dt>
        <div class="global-icon"
             style="width: 24px; height: 24px; -webkit-mask-image: url('assets/icons/phone.svg'); mask-image: url('assets/icons/phone.svg');"
             aria-label="phone">
        </div>
      </dt>
      <dt>{{ telInfo && telInfo !== 'false' ? telInfo : '-' }}</dt>
    </dl>

    <dl *ngIf="mailInfo" fxLayout fxLayoutGap="20px">
      <dt>
        <div class="global-icon"
             style="width: 24px; height: 24px; -webkit-mask-image: url('assets/icons/email.svg'); mask-image: url('assets/icons/email.svg');"
             aria-label="email">
        </div>
      </dt>
      <dt>{{ mailInfo && mailInfo !== 'false' ? mailInfo : '' }}</dt>
    </dl>

    <dl fxLayout fxLayoutGap="20px">
      <dt>
        <div class="global-icon"
             style="width: 24px; height: 24px; -webkit-mask-image: url('assets/icons/time-24px.svg'); mask-image: url('assets/icons/time-24px.svg');"
             aria-label="time">
        </div>
      </dt>
      <dt>{{ parameter.openingTime }} – {{ parameter.closingTime }}</dt>
      <dt [ngClass]="{ open: (isOpen$ | async), closed: !(isOpen$ | async) }">
        {{ (isOpen$ | async) ? 'OUVERT' : 'FERMÉ' }}
      </dt>
    </dl>

    <dl fxLayout fxLayoutGap="20px" style="width: 100% !important">
      <dt>
        <div class="global-icon"
             style="width: 24px; height: 24px; -webkit-mask-image: url('assets/icons/location-24px.svg'); mask-image: url('assets/icons/location-24px.svg');"
             aria-label="location">
        </div>
      </dt>
      <dt>
        <a href="{{ parameter.mapsSharedLink }}" target="_blank">
          {{ parameter.address || '-' }}
        </a>
      </dt>
    </dl>

    <div style="margin-left: -1em; width: 108%;" *ngIf="iFrame$ | async as iFrame">
      <div style="width: 100%" [innerHtml]="iFrame"></div>
    </div>

    <div class="support-dialog-actions" fxLayout="row" fxLayoutGap="8px">
      <button mat-button class="app-button" fxFlex="50" (click)="sendEmail()">
        ENVOYER UN MAIL
      </button>
      <button mat-button class="app-raised-button" fxFlex="50" (click)="call()">
        Appelez-nous
      </button>
    </div>
  </div>
</div>
